module.exports = __webpack_public_path__ + "static/media/flag-white.330b21f5.svg";